import { useCurrentUser } from '../../security/hooks/useCurrentUser';
import { PermissionService } from '../../security/service/PermissionService';
import { PermissionType } from '../../security/type/PermissionType';

type UseCanViewPatientsTabHookReturn = boolean;

export const useCanViewPatientsTab = (): UseCanViewPatientsTabHookReturn => {
  const user = useCurrentUser();

  return PermissionService.hasOrgBranchPermission(PermissionType.CAN_VIEW_PATIENTS, user.orgIdsIncludingParents);
};
